import axios from 'axios';
import { useEffect, useRef } from 'react';
//import type { AxiosInstance } from 'axios';

import { useKeycloak } from '@react-keycloak/web';
import { useTranslation } from 'react-i18next';
import { environment } from '../environment';
import { ShowUserSessionExpiredNotificationWarning } from '../shared/Notifications/Toasters';
import { useTokenRefresh } from './useTokenRefresh';

export const useAxios = (baseURL = null, config, multipart = false) => {
  //const axiosInstance = useRef<AxiosInstance>();
  const { t } = useTranslation()
  const axiosInstance = useRef();
  const { keycloak, initialized } = useKeycloak();
  const { callKeycloakTokenRefresh } = useTokenRefresh()

  const kcToken = keycloak?.token || ''



  const defaultBackendDev = `${environment.apiServerUrl}${environment.apiEndpoint}`

  const backendUrl = (!process.env.REACT_APP_BACKEND_URL && !process.env.REACT_APP_API_ENDPOINT)
    ? defaultBackendDev
    : `${process.env.REACT_APP_BACKEND_URL}${process.env.REACT_APP_API_ENDPOINT}`

  const serverBaseUrl = baseURL || backendUrl //`${environment.apiServerUrl}${environment.apiEndpoint}`

  /* const handleAxiosErrors = (error) => {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      const { status, data, headers } = error.response
      const authenticated = keycloak?.authenticated
      console.log("RESPONSE ERROR ===========> ", { status, data, headers, authenticated });

      // ----------------------------------------------------
      // AUTO LOGOUT 
      // ----------------------------------------------------
      //If TOKEN is NOT VALID => LOGOUT & REDIRECT TO LOGIN
      // ----------------------------------------------------
      if (status === 401) {

        console.log("401 DETECTED ====================!!!")
        ShowUserSessionExpiredNotificationWarning(t)

        //TOKEN REFRESH WITH SUCCESS MESSAGE ON
        callKeycloakTokenRefresh(keycloak, axiosInstance.current, t, true)

      }

    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log("REQUEST ERROR ===========> ", { status: error.request.status });
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log('AXIOS ERROR ===========> ', error.message);
    }

  } */

  useEffect(() => {

    //console.log("KC TOKEN IS  1 ========================> ", kcToken.slice(-5))
    //console.log("KC TOKEN IS CREATING NEW AXIOS INSTANCE")

    axiosInstance.current = axios.create({
      baseURL: serverBaseUrl,
      headers: {
        //"Access-Control-Allow-Origin" : "*",
        'content-type': multipart ? 'multipart/form-data' : undefined,
        Authorization: initialized ? `Bearer ${kcToken}` : undefined,
      },
      ...config
    });


    // Add a response interceptor
    axiosInstance.current.interceptors.response.use(function (response) {
      // Any status code that lie within the range of 2xx cause this function to trigger
      // Do something with response data
      //alert("This is response", response?.statusText)
      //console.log("This is response", response?.status)
      return response;
    }, function (error) {
      // Any status codes that falls outside the range of 2xx cause this function to trigger
      // Do something with response error
      //handleAxiosErrors(error)
      return Promise.reject(error);
    });


    return () => {
      axiosInstance.current = undefined;
    };
  }, [serverBaseUrl, initialized, config, kcToken]);

  return { axiosInstance, kcToken };
};
